<template>
  <div class="welcome">
    <v-card flat max-width="500" class="mx-auto">
      <v-img style="height: 736px" src="/table-tennis.jpg">
        <v-row no-gutters align="center" justify="center" style="height: 100%">
            <v-col cols="12" style="height: 50%">
                <h1 class="ml-2 my-8 py-8 font-italic white--text">Table Tennis Manager</h1>
            </v-col>
            <v-col cols="12" style="height: 50%">
                <h3 class="my-6 py-6 text-center">
                    <Signup class="mx-2" />
                    <Login class="mx-2" />
                </h3>             
            </v-col>
        </v-row>
      </v-img>
    </v-card>
  </div>

</template>

<script>
import Signup from '@/components/Signup'
import Login from '@/components/Login'

export default {
  name: 'Welcome',
  components: { Signup, Login },
  data: () => ({

  })
};
</script>

<style>

</style>